import { PredictionSummaryData } from "../types";
import SummaryFieldRow from "./summaryFieldRow";

/**
 * Props for the Criteria tab.
 */
interface CriteriaTabProps {
  /** Evaluation engine payload containing criteria metadata. */
  data: PredictionSummaryData;
}

/**
 * Criteria tab showing source metadata and FDA/label text sections.
 *
 * @param props.data - Prediction summary payload
 */
const CriteriaTab = (props: CriteriaTabProps) => {
  const { criteria } = props.data;
  const text = criteria?.text;

  return (
    <div className="prediction-summary-modal__criteria flex flex-col overflow-y-auto">
      <SummaryFieldRow label="Source:">{criteria?.source || "—"}</SummaryFieldRow>
      <SummaryFieldRow label="RxCUI:">{criteria?.rxcui || "—"}</SummaryFieldRow>
      <SummaryFieldRow label="Resolution:">
        {criteria?.resolution || "—"}
      </SummaryFieldRow>
      <SummaryFieldRow label="Source ID:">
        {criteria?.source_id || "—"}
      </SummaryFieldRow>
      <SummaryFieldRow label="Indications:">
        {text?.indications || "—"}
      </SummaryFieldRow>
      <SummaryFieldRow label="Dosage:">{text?.dosage || "—"}</SummaryFieldRow>
      <SummaryFieldRow label="Contraindications:">
        {text?.contraindications || "—"}
      </SummaryFieldRow>
      <SummaryFieldRow label="Limitations:" isLast>
        {text?.limitations?.trim() ? text.limitations : "—"}
      </SummaryFieldRow>
    </div>
  );
};

export default CriteriaTab;
